import React from 'react';

import { Helpers } from '../../core/src/helpers';
import { Carousel,setCarouselHeight} from '../../shared/components/carousel';
import CarouselIndicator from '../../shared/components/carousel-indicator';
import ImageWithPlaceholder from '../../shared/components/image-with-placeholder';
import BrightCove from '../../shared/components/brightcove';

import '../css/pdp-mobile-image.less';

class PDPMobileImage extends React.Component {

    constructor(props) {
        super(props);
    }

    controls() {
		return {
			renderCenterLeftControls : () => null,
            renderCenterRightControls: () => null,
            renderBottomCenterControls: CarouselIndicator,
		}
    }

    render() {
        let { sku, images, defaultImages, selectedColor } = this.props;
        let settings = {
            slidesToShow: 1,
            slidesToScroll: 1,
            ...this.controls(),
            lazyLoad: true,
            initialSlideHeight: 170,
            initialSlideWidth: 270
        }
        
        let cdnImages = Helpers.getProductCDNImages({
            images,
            selectedColor,
            defaultImages,
            sku
        },[270]);

        return (
            <Carousel className='pdp-mobile-carousel' {...settings} ref={carousel => this.carousel = carousel}>
                {cdnImages.map((image, i) => {
                    const imageSrc = image.cdnMap ? image.cdnMap.get(270) : image.lrg;
                    return (
                        <div key={`${i}-${image.ordinal}`} className='pdp-mobile-image'>
                            {
                                image.type !== 'video' ?
                                <ImageWithPlaceholder
                                    src={imageSrc}
                                    onLoad={i === 0 ? () => setCarouselHeight(this.carousel) : null}
                                /> : <BrightCove src={image.src}/>
                            }
                        </div>
                    )
                })}
            </Carousel>
        );
    }

}

export default PDPMobileImage;
